function DocumentsController() {
    // Initialize the controller
    this.init.apply(this, arguments);
}

// Dependency injection for the controller
DocumentsController.$inject = ['$scope', 'DocumentService', '$state', '$message', 'AttackmentService'];

// Define the prototype methods for DocumentsController
DocumentsController.prototype = {
    total: 0, // Total number of notifications
    /** @type {DocumentDto[]} lists */
    list: [],
    displayExpiredDocuments: false,

    /**
     *
     * @param {angular.IScope} $scope - AngularJS scope object
     * @param  {DocumentService} DocumentService
     * @param {ui.IStateService} $state
     * @param {$message} $message
     * @param {AttackmentService} AttackmentService
     *
     */
    init($scope, DocumentService, $state, $message, AttackmentService) {
        this.$scope = $scope;
        this.documentService = DocumentService;
        this.$state = $state;
        this.$message = $message;
        this.attackmentService = AttackmentService;


        this.total = 0;
        this.list = [];


        this.refresh();
    },
    /**
     * Reloads notifications.
     * @returns {angular.IPromise<*>} A promise that resolves when the refresh is complete.
     */
    onReload: function () {
        return this.refresh();
    },

    /**
     * Refreshes the notification list.
     * @returns {angular.IPromise<*>} A promise that resolves with the updated list of notifications.
     */
    refresh: function () {
        return this.loadData().then((list) => {
            this.list = list;
            this.total = list.length;
            this.loaded = true;
        }, this.$message.error);
    },


    /**
     * Loads notifications from the service.
     * @returns {angular.IPromise<DocumentDto[]>} A promise that resolves with the list of notifications.
     */
    loadData() {
        return this.documentService.getDocuments(this.displayExpiredDocuments);
    },

    /**
     * Navigates back to the home page.
     */
    back() {
        this.$state.go(this.$state.params.prevState || 'internal.home');
    },
    /**
     * Opens the menu.
     * @param {Function} $mdOpenMenu - Function to open the menu.
     * @param {Object} ev - Event object.
     */
    openMenu($mdOpenMenu, ev) {
        $mdOpenMenu(ev); // Open the menu with the event
    },

    onToggleDisplayExpiredDocuments() {
        this.displayExpiredDocuments = !this.displayExpiredDocuments;
        this.refresh();
    },

    /**
     *
     * @param item {DocumentDto}
     */
    onItemClicked(item) {
        if(!item.DocumentId){
            return;
        }
        let downloadUrl = this.attackmentService.buildDocumentUrl(item.DocumentId) + "/" + item.DocumentName;
        this.download(downloadUrl);
    },
    
    download(downloadUrl) {
        if (window['cordova']) {
            window['cordova'].InAppBrowser.open(downloadUrl, '_system');
        } else {
            window.open(downloadUrl, '_blank');
        }
    }
};
// Register the DocumentsController controller with the AngularJS module
angular.module('internal.documents').controller('DocumentsController', DocumentsController);
